import React, { Suspense, lazy, useEffect } from 'react';
import { useWindowSize, useFetch } from 'utils/hooks';
import { DIGITAL_CONTENT_ITEM, LOCATION } from 'constants.js';
import { convertAlbum } from 'utils/itemUtil';
import { setMusicCurrency, setAlbumPrices } from 'context/player/actions';
import { useStateValue } from 'context/store';

const MobilePage = lazy(() =>
  import(/* webpackChunkName: "MobilePage" */ './MobilePage')
);

const DesktopPage = lazy(() =>
  import(/* webpackChunkName: "DesktopPage" */ './DesktopPage')
);

function MusicItemPage(props) {
  const { width } = useWindowSize();
  const {
    state: { player },
    dispatch
  } = useStateValue();
  const [res, { loading, error }] = useFetch(
    {},
    `${DIGITAL_CONTENT_ITEM}/${props.match.params.slug}`,
    { method: 'GET' },
    'album_item'
  );

  useFetch(
    {},
    LOCATION,
    {
      method: 'get'
    },
    'itemPageLocation'
  );

  useEffect(() => {
    dispatch(setMusicCurrency(res.currency));
    dispatch(setAlbumPrices(res.prices));
  }, [dispatch, res.currency, res.prices]);

  const { albumPrices, musicCurrency } = player;

  const albumPrice =
    albumPrices &&
    albumPrices.filter(price => price.price_currency === musicCurrency);

  const response = convertAlbum(res, albumPrice, musicCurrency);

  if (width === undefined || width === null) {
    // Wait for the window size
    return <div>{null}</div>;
  }

  if (width <= 992) {
    return (
      <Suspense fallback={<p>{null}</p>}>
        <MobilePage res={response} loading={loading} error={error} />
      </Suspense>
    );
  }
  // Desktop Page
  if (width > 992) {
    return (
      <Suspense fallback={<p>{null}</p>}>
        <DesktopPage res={response} loading={loading} error={error} />
      </Suspense>
    );
  }
  return null;
}

export default MusicItemPage;
